// extracted by mini-css-extract-plugin
module.exports = {"image":"ProductBox_image__1bD5Z","item":"ProductBox_item__1I4Hb","active":"ProductBox_active__1t-4w","left":"ProductBox_left__1qmux","center":"ProductBox_center__26i4R"};